<template>
  <div v-if="allocatedQuotas.length > 0">
    <v-btn class="btn-add btn-link" @click="allocatedQuotaDialog = true">
      {{ $t("Выделенные квоты") }}
    </v-btn>
    <v-dialog v-model="allocatedQuotaDialog" max-width="440">
      <v-card class="modal">
        <div class="modal-head">
          {{ $t('Выделенные квоты') }}
          <v-btn color="modal-close" @click="allocatedQuotaDialog = false">
            <img src="@/assets/img/close-icon.png" alt="icon">
          </v-btn>
        </div>
        <div class="modal-body">
          <div class="table-overflow">
            <table class="table-full">
              <thead>
              <tr>
                <td>{{ $t('Вид животного') }}</td>
                <td>{{ $t('Кол-во голов') }}</td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, i) in allocatedQuotas" :key="i">
                <td>{{ item.faunaName }}</td>
                <td>{{ item.headCount }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    allocatedQuotas: Array
  },
  data: () => ({
    allocatedQuotaDialog: false
  })
}
</script>

<style lang="scss" scoped>
table {
  td {
    text-align: center;
  }
}
</style>
